import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { throttle } from 'throttle-debounce';
import PRSingleSidebar from './PRSingleSidebar';
import PRSingleReportPane from './PRSingleReportPane';

const supportPageOffset = window.pageXOffset !== undefined;
const isCSS1Compat = (document.compatMode || '') === 'CSS1Compat';

class PerformanceReportsSingle extends Component {
  constructor(props) {
    super(props);

    this.state = {
      allowWindowJump: true,
      scrollWatchDisabled: false,
    };
    this.disableScrollWatch = this.disableScrollWatch.bind(this);
    this.onScrollFunc = this.onScrollFunc.bind(this);
    this.scrollFn = throttle(333, this.onScrollFunc);
    this.toggleMenuClosed = (e) => {
      document.querySelector('.single-performance-report-group').classList.toggle('menu-closed');
    };
    this.componentReady = this.componentReady.bind(this);
  }

  disableScrollWatch() {
    this.setState({ scrollWatchDisabled: true }, () => {
      setTimeout(() => {
        this.setState({ scrollWatchDisabled: false }, this.onScrollFunc);
      }, 500);
    });
  }

  componentDidMount() {}

  componentReady() {
    window.addEventListener('scroll', this.scrollFn);
    this.reportChildren = document.querySelectorAll('#single-report-pane > section');
    document.querySelector('.toggle-sidebar').addEventListener('click', this.toggleMenuClosed);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollFn);
    document.querySelector('.toggle-sidebar').removeEventListener('click', this.toggleMenuClosed);
  }

  resetWindowJumpState() {
    this.setState({ allowWindowJump: true });
  }

  onScrollFunc() {
    if (!this.state.scrollWatchDisabled) {
      // console.log('Ran onScrollFunc()');
      let found = 0;
      let s = supportPageOffset
        ? window.pageYOffset
        : isCSS1Compat
          ? document.documentElement.scrollTop
          : document.body.scrollTop;
      s += window.innerHeight / 2;
      const children = [...document.querySelectorAll('#single-report-pane > section')];
      children.forEach((x, i) => {
        if (s > x.offsetTop) {
          found = i;
        }
      });

      this.setState({ allowWindowJump: false }, () => {
        this.props.history.replace(`/${this.props.match.params.report_slug}/${children[found].dataset.niceRoute}`);
        setTimeout(this.resetWindowJumpState.bind(this), 100);
      });
    }
  }

  render() {
    return (
      <div className="single-performance-report-group">
        <PRSingleSidebar {...this.props} disableScrollWatch={this.disableScrollWatch} />
        <PRSingleReportPane
          {...this.props}
          allowWindowJump={this.state.allowWindowJump}
          componentReady={this.componentReady}
        />
      </div>
    );
  }
}

PerformanceReportsSingle.propTypes = {
  history: PropTypes.shape({ push: PropTypes.func }).isRequired,
  match: PropTypes.shape({ params: PropTypes.shape({ report_slug: PropTypes.string.isRequired }) })
    .isRequired,
};

export default withRouter(PerformanceReportsSingle);
